const FrontendConfig = { 'env': "schur", 'rp_id': "schur.sharepass.com", 'api_endpoint': "https://api.schur.sharepass.com/v1", 'site_url': "https://app.schur.sharepass.com/" };
export default FrontendConfig;
